import translate from './translate';


/**
 * @type { import('didi').ModuleDeclaration }
 */
export default {
  translate: [ 'value', translate ]
};